import { createFileRoute, Outlet } from "@tanstack/react-router";

import { PermissionGuard } from "~/components/permission-guard";
import { ensureSession } from "~/modules/auth/credentials";

export const Route = createFileRoute("/_dash/actors")({
  component: RouteComponent,
  beforeLoad() {
    ensureSession();
  },
});

function RouteComponent() {
  return (
    <PermissionGuard permission="mirage-videos:view">
      <Outlet />
    </PermissionGuard>
  );
}
